import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import backgroundImage from '../../../../../assets/images/auth/handshake.png';
import mobileBackgroundImage from '../../../../../assets/images/auth/business-people.png';
import nameLogo from '../../../../../assets/images/name_logo_white.svg';
import useWindowDimensions from '../../../../common/hooks/useWindowDimensions';
import {useI18n} from '../../../../common/providers/I18nProvider';
import {useLayout} from '../../../../common/components/layout/LayoutProvider';
import {isMobile} from '../../../../common/helpers';

const AuthLayout = () => {
	useEffect(() => {
		const root = document.getElementById('root');
		if (root) {
			root.style.height = '100%';
		}
		return () => {
			if (root) {
				root.style.height = 'auto';
			}
		};
	}, []);
	const {height} = useWindowDimensions();

	const {i18n} = useI18n();
	const {showAuthNavbar} = useLayout();

	return (
		<div className='block sm:flex sm:flex-row'>
			{showAuthNavbar && (
				<div
					className='sm:flex sm:h-screen sm:fixed sm:w-2/5 bg-no-repeat bg-cover pt-[23px] sm:pt-0'
					style={{
						backgroundColor: '#304A73',
						backgroundImage: `url(${isMobile() ? mobileBackgroundImage : backgroundImage})`,
						backgroundSize: !isMobile() ? `100% ${height}px` : '',
					}}
				>
					<div className='flex flex-col m-auto justify-center items-center lg:mx-10 xl:mx-20 text-center h-[312px]'>
						<img className='mb-6 sm:w-[130px] lg:w-[158px]' src={nameLogo} alt='Knower' />
						<h3 className='text-white mb-3 font-bold text-lg sm:text-[23px]'>{i18n('JOINFREE')}</h3>
						<p className='text-white/[.8] px-2 lg:px-0 sm:text-[20px] lg:text-xl font-medium'>
							{i18n('AUTH.LAYOUT.TAGLINE')}
						</p>

						<div className='h-2/5' />
					</div>
				</div>
			)}

			<div className='sm:flex sm:w-3/5 sm:items-center sm:justify-center w-full sm:p-8 lg:p-10 sm:absolute sm:left-[40%] mt-[-85px] sm:mt-0 rounded-md '>
				<div className='bg-white sm:rounded rounded-t-2xl mt-7'>
					<Outlet />
				</div>
			</div>
		</div>
	);
};

export default AuthLayout;
